import { Component, Input, Output, EventEmitter, AfterContentInit, ContentChildren, QueryList, Injector, ViewEncapsulation } from '@angular/core';

import { CollectionService } from '../../../services/collection.service';
import { FilterCriteria, FilterSearchCriteria, Operator } from '../../../dataModels/grid-list';
import { SearchList } from '../searchList/search-list.component';
import { SortList } from '../sortList/sort-list.component';
import { DiagnosedItem } from '../../../dataModels/diagnosed-item';
import { inspect } from 'util';

@Component({
    moduleId: module.id,
    selector: 'list-view',
    templateUrl: 'list-view.component.html',
    providers: [CollectionService],
    encapsulation: ViewEncapsulation.None
})
export class ListView extends DiagnosedItem implements AfterContentInit {
    @Input() public hasHeader: boolean = true;
    @Input() collection: any[];
    @Input() url: string;
    @Input() filter: FilterCriteria;
    @Input() autoPaging: boolean = true;
    @Input() currentPage: number = 1;
    size: number = 9;
    @Input() headerText: string;
    @Input() additionalFilters: FilterSearchCriteria[];

    @Input() autoLoadData: boolean = true;

    @Output() collectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() newPage: EventEmitter<number> = new EventEmitter<number>();

    @ContentChildren(SearchList) searchChildren: SearchList[];
    @ContentChildren(SortList) sortChildren: SortList[];
    collectionIsRetreved: boolean = true;
    @Output() gettingCollectionStatuse: EventEmitter<boolean> = new EventEmitter<boolean>();
    get isEmpty() {
        return !this.collection || !(<any>this.collection).TotalCount;
    }

    get collectionCount() {
        return (<any>this.collection).TotalCount;
    }

    constructor(private _collectionService: CollectionService, protected __inj: Injector) {
        super(__inj);
        //debugger
        this.createFilterIfNull();

        this._collectionService.collectionReady.subscribe(result => {
            //debugger
            this.collection = result;

            this.collectionChange.next(result);
            this.collectionIsRetreved = true;
            this.gettingCollectionStatuse.emit(true);
        });

        this._collectionService.gettingCollection.subscribe(result => {
            // console.log("gettingCollection result", result)
            this.collectionIsRetreved = false;
            this.gettingCollectionStatuse.emit(false);
        })
    }

    ngAfterContentInit() {
        this.additionalFilters = this.additionalFilters || [];

        //if search Children exist
        if (this.searchChildren && this.searchChildren.length > 0) {

            //for each search list component
            this.searchChildren.forEach((item) => {

                //subscribe to valueChange event
                item.valueChange.subscribe(val => {
                    this.getFilteredData(val, item);

                })
            });
        }

        //if search Children exist
        if (this.searchChildren && this.searchChildren.length > 0 && this.autoLoadData) {

            //for each search list component
            this.searchChildren.forEach((item) => {

                //subscribe to clearEvent
                item.clearEvent.subscribe(val => {
                    this.getFilteredData(val, item);
                })
            });
        }

        //if search Children exist
        if (this.searchChildren && this.searchChildren.length > 0 && !this.autoLoadData) {
            this.searchChildren.forEach((item) => {
                item.clearEvent.subscribe(result => {
                    var arrayEmpty: any[] = [];
                    this.collection = arrayEmpty;
                    this.collectionChange.next(arrayEmpty);
                })
            });
        }

        //if search Children exist
        if (this.sortChildren && this.sortChildren.length > 0) {

            //for each search list component
            this.sortChildren.forEach((item) => {

                //subscribe to valueChange event
                item.sortChange.subscribe(val => {

                    //if filter not exist
                    if (!this.filter) {

                        //Create new Object
                        this.filter = new FilterCriteria();
                    }

                    //set PageNumber to zero
                    this.filter.PageNumber = 0;

                    //Set Sort Criteria
                    this.filter.SortCriteria = { Field: item.field, Direction: val };

                    //Load Page with filter
                    this.LoadPage(this.filter);

                })
            });
        }

        if (this.autoLoadData) {
            if (this.filter != null)
                this.LoadPage(this.filter);
            else
                this.LoadPage(null);
        }
    }

    pageChanged(event) {

        this.createFilterIfNull();

        this.updateFilter(event.page - 1);

        if (this.autoPaging) {
            this.LoadPage(this.filter);
        }

        this.newPage.emit(event.page - 1);
    }

    private LoadPage(filter: FilterCriteria, loader: boolean = true) {

        var filterCriteria = filter;

        this._collectionService.loadCollection(this.url, filterCriteria, loader);
    }

    Refresh(lastRow: boolean, url: string = "", loader: boolean = true) {
        if (lastRow && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
        }
        else {
            this.createFilterIfNull();

            if (url) {
                this.url = url;
            }

            this.LoadPage(this.filter, loader);
        }
    }



    getFilteredData(val: any, item: any): void {


        //if filter not exist
        this.createFilterIfNull();

        //set PageNumber to zero
        this.filter.PageNumber = 0;

        //create search criteria if not exist
        if (!this.filter.SearchCriteria || !this.filter.SearchCriteria.length) {

            this.filter.SearchCriteria = this.additionalFilters.slice(); // copy the array
        }

        //Find Index of Search Critria
        for (let field of item.fieldList) {

            var index: number = this.filter.SearchCriteria.findIndex(ct => ct.Field == field);

            if (item.operator == undefined)
                item.operator = Operator.Equal;

            if (index < 0 && val && (<string>val).trim() != "") {

                //push search criteria
                this.filter.SearchCriteria.push({ Field: field, SearchKey: val, Operator: item.operator, RelationOperator: item.relationOperator });
            }
            else {

                if (val && (<string>val).trim() != "") {

                    //Edit exist
                    this.filter.SearchCriteria[index] = { Field: field, SearchKey: val, Operator: item.operator, RelationOperator: item.relationOperator };
                }
                else { //Has not value

                    if (index >= 0)
                        //Remove it
                        this.filter.SearchCriteria.splice(index);
                }
            }
        }

        //Load Page with filter
        if (this.autoLoadData) {
            this.LoadPage(this.filter);
            this.currentPage = 0;
        }
        // for search without write any key search
        else if (!this.autoLoadData && !val) {
            var arrayEmpty: any[] = [];
            this.collection = arrayEmpty;
            this.currentPage = 0;
        }
        else {
            this.LoadPage(this.filter);
            this.currentPage = 0;
        }
    }

    private updateFilter(pageNumber: number) {
        this.filter.PageNumber = pageNumber;
        this.filter.PageCriteria.PageNumber = pageNumber;
    }

    private createFilterIfNull() {
        if (!(this.filter instanceof FilterCriteria)) {
            this.filter = new FilterCriteria();
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/listView/listView/list-view.component.ts